// @flow

import { apiService } from "../services/APIService";

const canUserWatchMasterClassWorkout = async ({
  programId,
}): Promise<boolean> => {
  const response = await apiService.checkAccessiblePlan({
    programId,
  });
  const itemNextWorkoutSlug = response?.accessibility?.find(
    (item) => item.done === 0
  );
  return !!itemNextWorkoutSlug?.canAccess;
};

const canUserWatchSlugWorkout = async ({
  programId,
  workoutSlug
}): Promise<boolean> => {
  const response = await apiService.checkAccessiblePlan({
    programId,
  });
  console.log({ responseWatchSlugWorkout: response });
  const itemWorkout = response?.accessibility?.find(
    (item) => item?.slug === workoutSlug
  );
  return !!itemWorkout?.canAccess;
};

export { canUserWatchMasterClassWorkout, canUserWatchSlugWorkout };
